import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button,
    Alert,
    UncontrolledAlert
} from "reactstrap"
import apiResponse from '../../../../../services/apiResponse';
import DetailBloc from '../Blocs/DetailBloc'

class MatrixKinerja extends Component {

  detailBloc = new DetailBloc()

    constructor(props) {
      super(props)
      this.state = {
        assessment_matrix : this.props.matrixid,
        msMatrix : [{}]
      }
    }
    loadMsMatrix = async () => {
      const query = {
          uuid: this.props.uuid
      }
      // console.log(query)
      await this.detailBloc.fetchMatrix(query)
    }
    componentDidMount() {
      this.loadMsMatrix()
      this.detailBloc.acMatrixChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log(response)
                      this.setState({
                          msMatrix : response
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      
  }
    render() {
      return (
        <Fragment>
          <Card>
            <CardBody>
              <CardTitle className="h4 mb-4">
              KOTAK MANAJEMEN TALENTA (TALENT MANAGEMENT BOX)
              </CardTitle>
              <Row>
                <Col sm={1} style={{backgroundColor:'lavender'}}>
                  <div align={'center'} valign={'center'}>
                    <h4 style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left',marginTop:'238px'}}>KINERJA</h4>
                  </div>
                </Col>
                <Col sm={1}>
                  <div align={'center'} valign={'center'}>
                    <b style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left',marginBottom:'50px',marginTop:'20px'}}><u>DIATAS EKSPEKTASI</u></b>
                    <br />
                    <b style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left',marginBottom:'50px'}}><u>SESUAI EKSPEKTASI</u></b>
                    <br />
                    <b style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left'}}><u>DIBAWAH EKSPEKTASI</u></b>
                  </div>
                </Col>
                <Col sm={6}>
                  <Row>
                    {
                      this.state.msMatrix.map((data,index)=>{
                        return(
                          <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                            <div
                              color="secondary"
                              className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                              
                            >
                              {
                                this.state.assessment_matrix == data.matrix_level ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">{data.matrix_level}</h5>
                              }
                              <p>{data.matrix_desc}</p>
                            </div>
                          </Col>
                        )

                      })

                    }
                    </Row>
                    {/* <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 7 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">7</h5>
                        }
                        <p>Kinerja di atas ekspektasi dan potensialmenengah</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 9 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">9</h5>
                        }
                        <p>Kinerja di atas ekspektasi dan potensial tinggi</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 2 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">2</h5>
                        }
                        <p>Kinerja sesuai ekspektasi dan potensial rendah</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 5 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">5</h5>
                        }
                        <p>Kinerja sesuai ekspektasi dan potensial menengah</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 8 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">8</h5>
                        }
                        <p>Kinerja sesuai ekspektasi dan potensial tinggi</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 1 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">1</h5>
                        }
                          <p>Kinerja di bawah ekspektasi dan potensial rendah</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 3 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">3</h5>
                        }
                        <p>Kinerjadi bawah ekspektasi dan potensial menengah</p>
                      </div>
                    </Col>
                    <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                      <div
                        color="secondary"
                        className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                        
                      >
                        {
                          this.state.assessment_matrix == 6 ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">6</h5>
                        }
                        <p>Kinerja di bawah ekspektasi dan potensial tinggi</p>
                      </div>
                    </Col> */}
                  {/* </Row> */}
                  <br />
                  <br />
                  <Row>
                    <Col sm={4} className="text-center">
                      <b><u>RENDAH</u></b>
                    </Col>
                    <Col sm={4} className="text-center">
                      <b><u>MENENGAH</u></b>
                    </Col>
                    <Col sm={4} className="text-center">
                      <b><u>TINGGI</u></b>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="mt-4" style={{backgroundColor:'lavender',padding:'20px'}}>
                      <div align={'center'} valign={'center'}>
                        <h4>POTENSIAL</h4>
                      </div>
                    </Col>
                  </Row>
                </Col>
                
              </Row>
            </CardBody>
          </Card>
        </Fragment>
      )
    }
  }
  export default MatrixKinerja